import { useState, useEffect } from "react";

export const useNavigation = (setShowFooter: (show: boolean) => void) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      setShowFooter(false);
    } else {
      document.body.style.overflow = "auto";
      setShowFooter(true);
    }

    return () => {
      document.body.style.overflow = "auto";
      setShowFooter(true);
    };
  }, [isOpen, setShowFooter]);
  return {
    isOpen,
    setIsOpen,
  };
};
